import React from 'react'
import { oneOfType, string, number, func, bool } from 'prop-types'
import { useSelector } from 'react-redux'
import { isCurrentPath } from '../../utilities/browser/comparePaths'

import LoadingDots from '../LoadingDots/LoadingDots'
import { appRoutes } from '../../configuration/constants'
import { selectLabels } from '../../redux/configuration/selectors'
import { formatPriceByLanguage } from '../../redux/configuration/utilities'
import { selectLanguage } from '../../redux/session/selectors'

const HeaderBreakdownToggle = React.forwardRef((props, ref) => {
  const { tripTotal, setIsOpen, isOpen, disabled, loading } = props
  const labels = useSelector(selectLabels)
  const lang = useSelector(selectLanguage)

  const isDisabled = disabled || isCurrentPath(appRoutes.ferryRoutes.pathname)

  return (
    <button
      className={`btn header-details__toggle ${isOpen ? 'active' : ''} ${
        process.env.REACT_APP_FLOW_CLIENT_ID
      } ${disabled ? 'disabled' : ''}`}
      onClick={() => setIsOpen(!isOpen)}
      disabled={isDisabled}
      ref={ref}
    >
      {loading && !isCurrentPath(appRoutes.ferryRoutes.pathname) ? (
        <LoadingDots color={'white'} />
      ) : (
        <h6 className="details-total">
          {tripTotal && !isCurrentPath(appRoutes.ferryRoutes.pathname)
            ? formatPriceByLanguage(tripTotal, lang)
            : labels.defaultPrice}
        </h6>
      )}
      <p className="details-label">{labels.details}</p>
    </button>
  )
})

HeaderBreakdownToggle.propTypes = {
  tripTotal: oneOfType([string, number]),
  setIsOpen: func.isRequired,
  isOpen: bool,
  disabled: bool,
  loading: bool
}

export default HeaderBreakdownToggle
